import { render, staticRenderFns } from "./TabsWithImagesAndText.vue?vue&type=template&id=62fb3dfa&scoped=true&"
import script from "./TabsWithImagesAndText.vue?vue&type=script&lang=ts&"
export * from "./TabsWithImagesAndText.vue?vue&type=script&lang=ts&"
import style0 from "./TabsWithImagesAndText.vue?vue&type=style&index=0&id=62fb3dfa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../home/bearlogin/development/pinq-project/mono2/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fb3dfa",
  null
  
)

export default component.exports